import DocsSitePreview from '@/business-components/docs-site-preview/DocsSitePreview';
import type { ErrorCodeMessageType } from '@/shared/constant/error/ErrorCodeMessageType';

export type NeedPreviewErrorProps = {
  value: ErrorCodeMessageType;
  className?: string;
};

export function NeedPreviewError(props: NeedPreviewErrorProps) {
  const { value } = props;
  return <DocsSitePreview value={value} />;
}
